import { useContext, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { useRefundProperties } from '../../../hooks/useRefundProperties';
import { useHasScope } from '../../../hooks/useHasScope';
import { JITA_USER, PAYMENTS_TRANSACTIONS_WRITE } from '../../../constants/scopes';
import { PermissionsContext } from '../../../context/PermissionsContext';
import { getRefundDisabledReasonsMessageKey } from '../../../constants/refundDisabledReasons';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
function RefundActionButton({
  objectId,
  externalAccountId,
  isAccountEnabled,
  paymentIntentId,
  processorType,
  refundTriggered,
  onClick
}) {
  const {
    isRefundable,
    loading,
    paymentMethod,
    refundDisabledReason
  } = useRefundProperties(objectId);
  const {
    canEditSubject
  } = useContext(PermissionsContext);
  const canEditTransactions = useHasScope(PAYMENTS_TRANSACTIONS_WRITE) && canEditSubject;
  const isJitaUser = useHasScope(JITA_USER);
  const validationMessage = useMemo(() => {
    if (!isAccountEnabled) {
      if (processorType === 'byo_stripe') {
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "cardPaymentHighlight.paymentHighlight.refundDisabled.refundInStripe_jsx",
          options: {
            href: `https://dashboard.stripe.com/${externalAccountId}/payments/${paymentIntentId}`
          },
          elements: {
            Link
          }
        });
      }
      if (processorType === 'hs_payments') {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.refundDisabled.disconnectedAccount"
        });
      }
    }
    if (!canEditTransactions && isJitaUser) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.refundDisabled.jitaUser"
      });
    }
    if (!canEditTransactions) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.refundDisabled.default"
      });
    }
    if (loading) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.refundPayment.refundLoadingEligibilityTooltip"
      });
    }
    if (refundTriggered) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.refundPayment.refundTriggeredTooltip"
      });
    }
    if (!isRefundable) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: getRefundDisabledReasonsMessageKey(refundDisabledReason, paymentMethod)
      });
    }
    return null;
  }, [isAccountEnabled, canEditTransactions, isJitaUser, loading, refundTriggered, isRefundable, processorType, externalAccountId, paymentIntentId, refundDisabledReason, paymentMethod]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: validationMessage,
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "payment-sidebar-actions--refund",
      onClick: onClick,
      disabled: Boolean(validationMessage),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.refundPayment.refund"
      })
    })
  });
}
export default RefundActionButton;